















































import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class TimelineControls extends Vue {
  isPlaying: boolean = true

  togglePlay () {
    if (this.computedIsPlaying) {
      this.isPlaying = false
      this.$emit('paused')
    } else {
      this.isPlaying = true
      this.$emit('played')
    }
  }

  change (type: string) {
    this.isPlaying = false
    this.$emit(type)
  }

  get computedIsPlaying () {
    return this.isPlaying
  }
}
